import React from 'react'
import { useCallback, useMemo } from 'sb-hooks'
import { constants, snowplow } from 'common/helpers'

import EmailSuggestionView from '../EmailSuggestionView/EmailSuggestionView'

import getSuggestion from './util/getSuggestion'


export type EmailSuggestionProps = {
  email: string
  onConfirm: (suggestion: string) => void
}

const EmailSuggestion: React.FunctionComponent<EmailSuggestionProps> = ({ email, onConfirm }) => {
  const suggestion = useMemo(() => getSuggestion(email), [ email ])
  const domain = suggestion.replace(/.*@/, '')

  const handleConfirm = useCallback(() => {
    snowplow.track('Email fixed')
    onConfirm(suggestion)
  }, [ suggestion, onConfirm ])

  return Boolean(suggestion) && (
    <EmailSuggestionView domain={domain} onConfirm={handleConfirm} />
  )
}


export default EmailSuggestion
